import { useQuery } from '@tanstack/react-query';
import { GetCategoriesParams, IProductCategoriesParams } from '../model/types';
import { categoryApi } from './client';

export const useCategories = (params: GetCategoriesParams) =>
  useQuery({
    queryKey: ['categories', params],
    queryFn: () => categoryApi.getAll(params),
  });

export const useCategoryWithProducts = (params: IProductCategoriesParams) =>
  useQuery({
    queryKey: ['products', 'product-categories', params],
    queryFn: () => categoryApi.getCategoryProducts(params),
    enabled: !!params.partner_shipper_id,
  });
